import { InlineOption } from "@/Common/Components/Inputs/InlineOptionsControl";
import { OntarioObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { OntarioObstetricalFileFieldLimits } from "@/Patient/Components/MedicalNote/ObstetricalFile/Form/Ontario/OntarioObstetricalFileFieldLimits";
import { OntarioObstetricalSwabResultEnum } from "@/Patient/Models/ObstetricalFile/Ontario/OPR3/OntarioObstetricalSwabResultEnum";

class OntarioObstetricalFileSpecialCircumstancesGbs extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        return (
            <div className="section border border-top">
                <div className="row">
                    {this.renderSpecialCircumstancesSection()}
                    {this.renderGbsSection()}
                </div>
            </div>
        );
    }

    private renderSpecialCircumstancesSection(): JSX.Element {
        const specialCircumstances = this.props.form.Opr3.SpecialCircumstances;
        const socialCircumstancesId = "SocialCircumstances";

        return (
            <div className="col-md-8 border border-right">
                {this.renderSubTitle("ObstetricalFile_SpecialCircumstancesLabel")}
                <div className="row row-form">
                    <div className="col-md-12">
                        <div className="flex-row">
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_LowDoseAcetylsalicylicAcidIndicatedLabel",
                                specialCircumstances.LowDoseAcetylsalicylicAcidIndicated,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.SpecialCircumstances.LowDoseAcetylsalicylicAcidIndicated = value),
                                "col-auto checkbox-large-margin-right",
                                "text-bold"
                            )}
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_ProgesteroneIndicatedLabel",
                                specialCircumstances.ProgesteroneIndicated,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.SpecialCircumstances.ProgesteroneIndicated = value),
                                "col-auto checkbox-large-margin-right",
                                "text-bold"
                            )}
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_HerpesSuppressionIndicatedLabel",
                                specialCircumstances.HerpesSuppressionIndicated,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.SpecialCircumstances.HerpesSuppressionIndicated = value),
                                "col-auto",
                                "text-bold"
                            )}
                        </div>
                    </div>
                </div>
                <div className="row row-form">
                    <div className="col-md-12">
                        {this.renderSimpleField(
                            "ObstetricalFile_SocialCircumstancesLabel",
                            this.controlRenderer.renderTextbox({
                                value: this.props.form.Opr3.SpecialCircumstances.SocialCircumstances,
                                onChange: social => this.props.mutateModelState(s => s.Opr3.SpecialCircumstances.SocialCircumstances = social),
                                id: socialCircumstancesId,
                                clickableTextOptions: this.getClickableTextOptions(socialCircumstancesId, OntarioObstetricalFileClickableTextContext.Opr3_SpecialCircumstancesSocialComment),
                                maxLength: OntarioObstetricalFileFieldLimits.Page3.SpecialCircumstances_SocialCircumstances.MaxChars
                            })
                        )}
                    </div>
                </div>
            </div>
        );
    }

    private renderGbsSection(): JSX.Element {
        return (
            <div className="col-md-4">
                {this.renderSubTitle("ObstetricalFile_GroupBStreptococcusAbbrevLabel")}
                <div className="row row-form">
                    <div className="col-md-12 flex-display">
                        <span className="bold margin-md-right">{this.getString("ObstetricalFile_RectovaginalSwabLabel")}</span>
                        {this.controlRenderer.renderUniqueCheckBoxList(
                            this.getGbsRectovaginalSwabOptions(),
                            this.props.form.Opr3.GbsRectovaginalSwab,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.GbsRectovaginalSwab = value),
                            "GbsRectovaginalSwab"
                        )}
                    </div>
                </div>
                <div className="row row-form">
                    <div className="col-md-12 flex-display">
                        <span className="bold margin-md-right">{this.getString("ObstetricalFile_OtherIndicationsForProxphylaxisLabel")}</span>
                        {this.controlRenderer.renderInlineYesNoRadio(
                            this.props.form.Opr3.OtherIndicationsForProxphylaxis,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.OtherIndicationsForProxphylaxis = value),
                            "OtherIndicationsForProxphylaxis",
                            "margin-right-15px"
                        )}
                    </div>
                </div>
            </div>
        );
    }

    private getGbsRectovaginalSwabOptions(): InlineOption<OntarioObstetricalSwabResultEnum>[] {
        return [
            new InlineOption<OntarioObstetricalSwabResultEnum>(OntarioObstetricalSwabResultEnum.Positive, "pos"),
            new InlineOption<OntarioObstetricalSwabResultEnum>(OntarioObstetricalSwabResultEnum.Negative, "neg")
        ];
    }
}

export { OntarioObstetricalFileSpecialCircumstancesGbs };
